import React, { useState, useEffect } from "react";
// import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import styles from "./FilterCards.module.css";
import { rarityEnum } from "../../../enums/rarityEnum";
import globalStyles from "../../../styles/globalStyles.module.css";
// import Booster from "../../Boosters/Booster";
// import { sortOrderEnum } from "../../../enums/sortOrderEnum";
import { ShowCardsType } from "../../../services/CardServices";
import { useTranslation } from "react-i18next";

const FilterCards: React.FC<{
  cards: ShowCardsType[];
  handleFilterCards: (cards: ShowCardsType[]) => void;
}> = ({ cards, handleFilterCards }) => {
  // const { cards, setFilteredCards } = useCreatorCardsContext();
  const [textFilter, setTextFilter] = useState<string>(""); // Default selected value
  // const [sortOrder, setSortOrder] = useState<sortOrderEnum | null>(null);
  const [rarityFilter, setRarityFilter] = useState<rarityEnum | null>(null); // Track the selected rarity
  // const [isBoosterFilter, setIsBoosterFilter] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    let updatedCards = cards;

    // Apply text filter
    if (textFilter !== "") {
      updatedCards = updatedCards.filter((card) =>
        card.name.toLowerCase().includes(textFilter.toLowerCase())
      );
    }

    // Apply rarity filter if checked
    if (rarityFilter) {
      updatedCards = updatedCards.filter(
        (card) => card.rarity === rarityFilter
      );
    }

    // too expensive to run
    // if (sortOrder) {
    //   if (textFilter !== "") {
    //     updatedCards = updatedCards.sort((a, b) => {
    //       const comparison = a.name.localeCompare(b.name);
    //       return sortOrder === sortOrderEnum.ascending
    //         ? comparison
    //         : -comparison;
    //     });
    //   } else {
    //     console.log("inside2");
    //     updatedCards.sort((a, b) => {
    //       const dateA = new Date(a.created_at).getTime();
    //       const dateB = new Date(b.created_at).getTime();

    //       if (isNaN(dateA) || isNaN(dateB)) {
    //         console.error("Invalid date format", a.created_at, b.created_at);
    //         return 0;
    //       }

    //       return sortOrder === sortOrderEnum.ascending
    //         ? dateA - dateB
    //         : dateB - dateA;
    //     });
    //   }
    // }
    handleFilterCards(updatedCards);

    // remove setFilteredCards warning ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textFilter, rarityFilter]); // sortOrder,

  // const toggleSortOrder = () => {
  //   if (sortOrder === sortOrderEnum.ascending) {
  //     setSortOrder(sortOrderEnum.descending);
  //     return;
  //   }
  //   if (sortOrder === sortOrderEnum.descending) {
  //     setSortOrder(null);
  //     return;
  //   }
  //   if (sortOrder === null) {
  //     setSortOrder(sortOrderEnum.ascending);
  //     return;
  //   }
  // };

  const toggleRarity = (rarity: rarityEnum) => {
    // When rarity is clicked, toggle between selecting and deselecting
    if (rarityFilter === rarity) {
      setRarityFilter(null); // If the same rarity is clicked, deselect it
    } else {
      setRarityFilter(rarity); // Otherwise, set the clicked rarity
    }
  };

  // const toggleBooster = () => {
  //   setIsBoosterFilter(!isBoosterFilter);
  // };

  return (
    <div
      className="d-flex justify-content-end align-items-center gap-2"
      style={{ margin: "10px" }}
    >
      {/* <button
          className={`${styles.rarityFilter} ${
            isBoosterFilter ? styles.activeIcon : ""
          }`}
          onClick={toggleBooster}
        >
          In booster
        </button> */}
      <button
        className={`${styles.rarityFilter} ${
          rarityFilter === rarityEnum.gold ? styles.activeIcon : ""
        }`}
        onClick={() => toggleRarity(rarityEnum.gold)}
      >
        {t("gold")}
      </button>
      <button
        className={`${styles.rarityFilter} ${
          rarityFilter === rarityEnum.silver ? styles.activeIcon : ""
        }`}
        onClick={() => toggleRarity(rarityEnum.silver)}
      >
        {t("silver")}
      </button>
      <button
        className={`${styles.rarityFilter} ${
          rarityFilter === rarityEnum.common ? styles.activeIcon : ""
        }`}
        onClick={() => toggleRarity(rarityEnum.common)}
      >
        {t("common")}
      </button>{" "}
      {/* <button
          className={`${styles.iconButton} ${
            sortOrder !== null ? styles.activeIcon : ""
          }`}
          onClick={toggleSortOrder}
        >
          {sortOrder === sortOrderEnum.ascending ? (
            <FaArrowUp />
          ) : (
            <FaArrowDown />
          )}
        </button> */}
      <input
        type="text"
        className={`${globalStyles.input} w-25`}
        value={textFilter}
        min={3}
        onChange={(e) => setTextFilter(e.target.value)}
        placeholder={t("cards.filter.name")}
      />
    </div>
  );
};

export default FilterCards;
